export let BillingCycle = /*#__PURE__*/function (BillingCycle) {
  BillingCycle["YEAR"] = "year";
  BillingCycle["MONTH"] = "month";
  return BillingCycle;
}({});